import { fetchApi } from '@/config/axiosSetting';
import {
  GetInsurerInformationTabsQueryParams,
  GetInsurerInformationTabsTabType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getInsurerInformationTabs/getInsurerInformationTabs.type';

export const getInsurerInformationTabsQueryFunction = (
  params: GetInsurerInformationTabsQueryParams,
): Promise<GetInsurerInformationTabsTabType[]> => {
  return fetchApi.get(`/body/reports/${params?.id}/entry_tabs/`, {
    params,
  });
};
